import type { TypedAmountTypeOption } from "../typedAmountTypes";

const NOT_INCLUDED: TypedAmountTypeOption = {
  value: "notIncluded",
  label: "Not Included",
  hideAmount: true,
};
const NOT_DISCLOSED: TypedAmountTypeOption = {
  value: "notDisclosed",
  label: "Not Disclosed",
  hideAmount: true,
};
const NOT_OFFERED: TypedAmountTypeOption = {
  value: "notOffered",
  label: "Not Offered",
  hideAmount: true,
};

const DOLLAR_ONLY_OPTIONS: TypedAmountTypeOption[] = [
  { value: "dollarAmount", label: "Dollar amount" },
  NOT_INCLUDED,
  NOT_DISCLOSED,
  NOT_OFFERED,
];

const RATE_GUARANTEE_OPTIONS = [
  { value: "months", label: "Months" },
  { value: "years", label: "Years" },
  NOT_OFFERED,
  NOT_INCLUDED,
];

export interface WholeLifeTypedAmountSpec {
  typeKey: string;
  amountKey: string;
  amountLabel: string;
  typeOptions: TypedAmountTypeOption[];
  amountMin?: number;
  amountInteger?: boolean;
}

export const wholeLifeTypedAmountFields: Record<
  string,
  WholeLifeTypedAmountSpec
> = {
  spouseBenefitAmount: {
    typeKey: "spouseBenefitAmountType",
    amountKey: "spouseBenefitAmountAmount",
    amountLabel: "Amount",
    typeOptions: DOLLAR_ONLY_OPTIONS,
  },
  spouseBenefitMaximum: {
    typeKey: "spouseBenefitMaximumType",
    amountKey: "spouseBenefitMaximumAmount",
    amountLabel: "Amount",
    typeOptions: DOLLAR_ONLY_OPTIONS,
  },
  childBenefitAmount: {
    typeKey: "childBenefitAmountType",
    amountKey: "childBenefitAmountAmount",
    amountLabel: "Amount",
    typeOptions: DOLLAR_ONLY_OPTIONS,
  },
  childBenefitMaximum: {
    typeKey: "childBenefitMaximumType",
    amountKey: "childBenefitMaximumAmount",
    amountLabel: "Amount",
    typeOptions: DOLLAR_ONLY_OPTIONS,
  },
  rateGuarantee: {
    typeKey: "rateGuaranteeType",
    amountKey: "rateGuaranteeAmount",
    amountLabel: "Amount",
    typeOptions: RATE_GUARANTEE_OPTIONS,
    amountMin: 1,
    amountInteger: true,
  },
};
